
import Vue from 'vue';

import { Banniere } from '@/model/banniere';

interface Item {
  type: 'VIDEO' | 'IMG',
  file: string,
  title: string
}

export default Vue.extend({
  name: 'BannierePub',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    cycle: true,
    interval: null,
    itemFullscreen: null as Item | null
  }),
  computed: {
    showDialog: {
      get () {
        return !!this.itemFullscreen;
      },
      set (val: any) {
        if (!val) {
          this.itemFullscreen = null;
        }
      }
    },
    cycleEnable (): boolean {
      return !!(this.cycle && this.itemFullscreen && !this.videoIsPlaying());
    },
    bannieres () {
      return (this.items as Banniere[]).filter(b => b.mediaLink && b.status);
    }
  },
  created () {
    this.interval = setInterval(this.next, 20000);
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
  methods: {
    displayFullScreen (item: Item) {
      this.itemFullscreen = item;
    },
    next () {
      if (this.cycle && !this.itemFullscreen && !this.videoIsPlaying()) {
        (this.$refs.carousel as any).next();
      }
    },
    videoIsPlaying (): boolean {
      for (const key in this.$refs) {
        if (key.startsWith('video-')) {
          const element = (this.$refs[key] as any)[0] as HTMLVideoElement;
          if (element.paused === false) {
            return true;
          }
        }
      }

      return false;
    },
    isVideo (item: Banniere): boolean {
      const videosExtensions = ['mp4', 'mov', 'avi'];
      return videosExtensions.some(ext => item.mediaLink.split('.').pop() === ext);
    }
  }
});
